module.exports = __webpack_public_path__ + "static/matza_2@1x-d3e1f1643e6f90c0427dfd6ee33d888d.jpg";